import React from 'react';
import CardsGrid from "../CardsGrid";
import Grid from "../Grid";
import Card from "../Card";
import Container from "../Container";
import IconWord from '../../public/images/word.svg';
import IconExcel from '../../public/images/excel.svg';
import IconJpg from '../../public/images/jpg.svg';
import IconPng from '../../public/images/png.svg';
import IconPpt from '../../public/images/ppt.svg';
import {useTranslation} from "next-i18next";

const GridConvertPdf = () => {
  const { t } = useTranslation(['common', 'index', 'edit-pdf']);

  return (
    <Container className="mt-xs-3 mb-xs-3 mb-md-4">
      <h3>{t('index:convert-pdf.title')}</h3>
      <CardsGrid>
        <Grid.Item>
          <Card
            href="/pdf-to-word"
            title={t('common:cards.pdf-to-word.title')}
            text={t('common:cards.pdf-to-word.text')}
            size='md'
            icon={IconWord}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/pdf-to-excel"
            title={t('common:cards.pdf-to-excel.title')}
            text={t('common:cards.pdf-to-excel.text')}
            size='md'
            icon={IconExcel}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/pdf-to-jpg"
            title={t('common:cards.pdf-to-jpg.title')}
            text={t('common:cards.pdf-to-jpg.text')}
            size='md'
            icon={IconJpg}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/pdf-to-png"
            title={t('common:cards.pdf-to-png.title')}
            text={t('common:cards.pdf-to-png.text')}
            size='md'
            icon={IconPng}
          />
        </Grid.Item>
        <Grid.Item>
          <Card
            href="/pdf-to-ppt"
            title={t('common:cards.pdf-to-ppt.title')}
            text={t('common:cards.pdf-to-ppt.text')}
            size='md'
            icon={IconPpt}
          />
        </Grid.Item>
      </CardsGrid>
    </Container>
  );
};

export default GridConvertPdf;
